import React from 'react';

import { Message } from '../../types';

import styles from './MessageDetails.module.css';

export function MessageDetails({ message }: { message: Message }) {
  const { createdAt, senderStatus, isOutgoing } = message;

  let status: string = senderStatus;
  if (senderStatus === 'SENT') {
    status = 'DELIVERED';
  }

  return (
    <div className={styles.messageDetails}>
      <span className={styles.timestamp}>
        {createdAt.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}
      </span>
      {isOutgoing && <span className={styles.status}>{mapStatusToReadableLabel(status)}</span>}
    </div>
  );
}

function mapStatusToReadableLabel(status: string) {
  switch (status) {
    case 'SENDING':
      return 'Sending...';
    case 'FAILED':
      return 'Send Failed';
    case 'RETRYING':
      return 'Retrying';
    case 'DELIVERED':
      return 'Delivered';
    default:
      return '';
  }
}

export default MessageDetails;
